<template>
  <div id="login">
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack uk-flex-center" uk-grid>
          <img src="../assets/logo.png" width="400ev" height="250ev" alt uk-img />
        </div>
        <div
          class="uk-grid-margin uk-grid uk-grid-stack"
          uk-grid
        >Se connecter à votre compte Check my House vous permet de payer vos factures directement sur le site et de voir plus rapidement un de nos professionels réaliser les prestations que vous souhaitez.</div>
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m">
            <div
              class="uk-margin uk-width-large uk-margin-auto uk-card uk-card-default uk-card-body uk-box-shadow-large uk-border-rounded"
            >
              <h3 class="uk-card-title uk-text-center">Bienvenue</h3>
              <form>
                <div class="uk-margin">
                  <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: mail"></span>
                    <input
                      placeholder="votre.email@exemple.com"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="text"
                      v-model="email"
                    />
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input
                      v-model="password"
                      v-bind:class="[!passwordMatch ? 'uk-form-danger' : '']"
                      placeholder="Mot de passe"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="password"
                    />
                  </div>
                </div>
                <div class="uk-margin" v-show="!isSignInMod">
                  <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input
                      v-model="passwordConfirmation"
                      v-bind:class="[!passwordMatch ? 'uk-form-danger' : '']"
                      placeholder="Confirmer votre mot de passe"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="password"
                    />
                  </div>
                </div>
                <div class="uk-margin">
                  <button
                    type="button"
                    v-on:submit.prevent="onSubmit"
                    class="uk-button uk-button-primary uk-button-large uk-width-1-1 uk-border-rounded uk-text-bold"
                    v-on:click="isSignInMod ? signIn() : signUp()"
                  >{{isSignInMod ? 'Se connecter' : 'S\'inscrire'}}</button>
                  <div
                    class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
                    uk-spinner
                    v-show="isLoading"
                  ></div>
                </div>
                <div class="uk-text-small uk-text-center">
                  <p v-show="isSignInMod">
                    Pas encore de compte ?
                    <a v-on:click="isSignInMod = !isSignInMod">Créer un compte</a>
                  </p>
                  <p v-show="!isSignInMod">
                    Vous avez déjà un compte ?
                    <a
                      v-on:click="isSignInMod = !isSignInMod"
                    >Se connecter</a>
                  </p>
                </div>
                <div class="uk-text-small uk-text-center">
                  <a
                    v-show="isSignInMod"
                    uk-toggle
                    href="#reset-password-modal"
                  >J'ai oublié mon mot de passe</a>
                  <div id="reset-password-modal" uk-modal>
                    <div
                      class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-border-rounded"
                    >
                      <button class="uk-modal-close-default" type="button" uk-close></button>
                      <h2 class="uk-modal-title">Entrez votre adresse email</h2>
                      <div class="uk-modal-body">
                        <div class="uk-margin">
                          <div class="uk-inline uk-width-1-1">
                            <span class="uk-form-icon" uk-icon="icon: mail"></span>
                            <input
                              v-model="resetPasswordEmailRecuperation"
                              placeholder="votre.email@exemple.com"
                              class="uk-input uk-form-large uk-border-rounded"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="uk-text-right">
                        <button
                          class="uk-button uk-button-default uk-modal-close uk-border-rounded uk-margin-right"
                          type="button"
                        >Annuler</button>
                        <button
                          v-on:click="resetPassword()"
                          class="uk-button uk-button-primary uk-border-rounded uk-modal-close"
                          type="button"
                        >Envoyer</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import UIkit from "uikit";
import router from "../router";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      isSignInMod: true,
      email: "",
      password: "",
      passwordConfirmation: "",
      resetPasswordEmailRecuperation: "",
      isLoading: false,
      passwordMatch: true
    };
  },

  mounted() {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        firebase
          .firestore()
          .collection("Users")
          .doc(firebase.auth().currentUser.uid)
          .get()
          .then(snapshot => {
            var data = snapshot.data();
            data.uid = firebase.auth().currentUser.uid;
            const parsed = JSON.stringify(data);
            localStorage.setItem("currentUser", parsed);
            router.push({ path: "home" });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      }
    });
  },

  methods: {
    signIn: function() {
      this.isLoading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch(error => {
          // Handle Errors here.
          this.isLoading = false;
          var errorCode = error.code;
          var errorMessage = error.message;
          this.displayErrorMessage(errorCode + ' ' + errorMessage);
          // ...
        });
    },

    signUp: function() {
      if (!this.arePasswordMatching())
        return 
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then( user => {
          console.log(user)
          firebase
            .firestore()
            .collection("Users")
            .doc(firebase.auth().currentUser.uid)
            .set({ uid: firebase.auth().currentUser.uid })
        })
        .catch(error => {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.displayErrorMessage(errorCode + ' ' + errorMessage);
          // ...
        });
    },

    arePasswordMatching: function() {
      if (this.password !== this.passwordConfirmation) {
        this.displayErrorMessage("Les mots de passe ne sont pas identiques.");
        return this.passwordMatch = false;
      }
      return this.passwordMatch = true;
    },

    resetPassword: function() {
      const self = this
      firebase
        .auth()
        .sendPasswordResetEmail(self.resetPasswordEmailRecuperation)
        .then(function() {
          self.displaySuccessMessage('Un email vous a été envoyé à l\'adresse ' + self.resetPasswordEmailRecuperation + '.')
          self.resetPasswordEmailRecuperation = ''
        })
        .catch(error => {
          console.log(error)
          self.displayErrorMessage(error)
          self.resetPasswordEmailRecuperation = ''
        });
    },

    isEmail: function() {},

    isSamePassword: function() {},

    displayErrorMessage: function(errorMessage) {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> " + errorMessage,
        { pos: "bottom-center", status: "danger" }
      );
    },

    displaySuccessMessage: function(message) {
      UIkit.notification(
        "<span uk-icon='icon: check'></span> " + message,
        { pos: "bottom-center", status: "success" }
      );
    }

  }
};
</script>

<style scoped>
body {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 400'%3E%3Cdefs%3E%3CradialGradient id='a' cx='396' cy='281' r='514' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23ffffff'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='400' y1='148' x2='400' y2='333'%3E%3Cstop offset='0' stop-color='%232a93ac' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%232a93ac' stop-opacity='0.5'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='400'/%3E%3Cg fill-opacity='0.4'%3E%3Ccircle fill='url(%23b)' cx='267.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='532.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='400' cy='30' r='300'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

a:hover {
  text-decoration: none;
  color: #2c3e50;
}
</style>